import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import { EmailTypeEnum, emailTypeTitle } from 'modules/email-statistics/enums/email-type-enum';
import { SystemeEmailStatusEnum, systemeEmailStatusTitles } from 'modules/email-statistics/enums/systeme-email-status-enum';
import { useEmailStatisticsTable } from 'modules/email-statistics/hooks/use-email-statistics-table';
import { EmailStatisticsFilterInterface, EmailStatisticsTableInterface } from 'modules/email-statistics/types/email-statistics-interface';
import { getBouncedColor, getOpenedColor, getSpamReportColor } from 'modules/email-statistics/utils/get-email-delivery-status';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateFormat } from 'shared/utils/date-time-format';
import { getPercentAndAmountStatistic } from 'shared/utils/get-percent-and-amount-statistic';
interface EmailDashboardTableProps {
  filter: EmailStatisticsFilterInterface;
}
const isNewsletter = (emailType: EmailTypeEnum) => emailType === EmailTypeEnum.newsletter || emailType === EmailTypeEnum.newsletter_split_test;
const EmailStatisticsTable = t0 => {
  const $ = _c(55);
  const {
    filter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    pagination,
    setPagination,
    limit,
    setLimit
  } = usePagination(true);
  let t1;
  if ($[0] !== filter || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      limit,
      pagination,
      filter
    };
    $[0] = filter;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    emailDashboardTable
  } = useEmailStatisticsTable(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.email_statistics.emails_subject");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t || $[7] !== user?.dateFormat || $[8] !== user?.timezone) {
    t3 = email => <div className="flex w-full items-center gap-3 truncate"><div className="flex w-full flex-col truncate"><LinkWithoutPrefetch className="primary-link max-w-fit truncate" href={`/mailing/${email.id}/statistics`}>{email.subject}</LinkWithoutPrefetch><div className="w-fill flex gap-1.5"><span className="truncate text-xs">{t(emailTypeTitle[email.emailType])}</span>{isNewsletter(email.emailType) && email.scheduledAt ? <span className="truncate text-xs">{dateFormat(email.scheduledAt, {
              dateFormat: user?.dateFormat,
              timeZone: user?.timezone
            })}</span> : email.isNewsletterRemoved ? <span className="truncate text-xs">{t("dashboard.email_statistics.table.over_month_ago").toLowerCase()}</span> : null}</div></div>{(email.status === SystemeEmailStatusEnum.blocked || email.status === SystemeEmailStatusEnum.pending) && <span className="text-danger">{t(systemeEmailStatusTitles[email.status])}</span>}</div>;
    $[6] = t;
    $[7] = user?.dateFormat;
    $[8] = user?.timezone;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = {
      key: "mailing",
      header: t2,
      widthPercent: 40,
      onRender: t3
    };
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("dashboard.email_statistics.amount_sent");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = {
      key: "stats",
      header: t5,
      widthPercent: 15,
      onRender: _temp
    };
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t) {
    t7 = t("dashboard.email_statistics.amount_opened");
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = {
      key: "stats",
      header: t7,
      widthPercent: 15,
      onRender: _temp2
    };
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t("dashboard.email_statistics.spam_percent_description");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t) {
    t10 = t("dashboard.email_statistics.spam_reports");
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      key: "stats",
      header: <Hint label={t9}>{t10}</Hint>,
      widthPercent: 15,
      onRender: _temp3
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("dashboard.email_statistics.bounced");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = {
      key: "stats",
      header: t12,
      widthPercent: 15,
      onRender: _temp4
    };
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t13 || $[34] !== t4 || $[35] !== t6 || $[36] !== t8) {
    t14 = [t4, t6, t8, t11, t13];
    $[32] = t11;
    $[33] = t13;
    $[34] = t4;
    $[35] = t6;
    $[36] = t8;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const columns = t14;
  let t15;
  if ($[38] !== t) {
    t15 = t("dashboard.email_statistics.emails");
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== pagination || $[41] !== setPagination) {
    t16 = {
      setPagination,
      pagination
    };
    $[40] = pagination;
    $[41] = setPagination;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== limit || $[44] !== setLimit) {
    t17 = {
      limit,
      setLimit
    };
    $[43] = limit;
    $[44] = setLimit;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== columns || $[47] !== emailDashboardTable || $[48] !== t16 || $[49] !== t17) {
    t18 = <Table data={emailDashboardTable} columns={columns} paginator={t16} limiter={t17} />;
    $[46] = columns;
    $[47] = emailDashboardTable;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== emailDashboardTable || $[52] !== t15 || $[53] !== t18) {
    t19 = <div><ListingLayout data={emailDashboardTable} title={t15} counter={false} type="compact">{t18}</ListingLayout></div>;
    $[51] = emailDashboardTable;
    $[52] = t15;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  return t19;
};
export default EmailStatisticsTable;
function _temp(email_0) {
  return <span>{email_0.stats.sentAmount}</span>;
}
function _temp2(email_1) {
  return <span className={getOpenedColor(email_1.stats.sentAmount, email_1.stats.openedAmount)}>{getPercentAndAmountStatistic({
      numberOfActions: email_1.stats.openedAmount,
      totalNumber: email_1.stats.sentAmount
    })}</span>;
}
function _temp3(email_2) {
  return <span className={getSpamReportColor(email_2.stats.openedAmountWithEnabledSpamReportFeedback, email_2.stats.spamReportAmount)}>{getPercentAndAmountStatistic({
      numberOfActions: email_2.stats.spamReportAmount,
      totalNumber: email_2.stats.openedAmountWithEnabledSpamReportFeedback
    })}</span>;
}
function _temp4(email_3) {
  return <span className={getBouncedColor(email_3.stats.sentAmount, email_3.stats.bouncedAmount, email_3.emailType)}>{getPercentAndAmountStatistic({
      numberOfActions: email_3.stats.bouncedAmount,
      totalNumber: email_3.stats.sentAmount
    })}</span>;
}